// Redux Actions

// Dictionary
export const INIT_DICTIONARY = 'dictionary/INIT_DICTIONARY';

// Get Standings
export const GET_STANDINGS_REQUEST = 'api/GET_STANDINGS_REQUEST';
export const GET_STANDINGS_SUCCESS = 'api/GET_STANDINGS_SUCCESS';
export const GET_STANDINGS_ERROR = 'api/GET_STANDINGS_ERROR';

// Get Standing Strip
export const GET_STANDING_STRIP_REQUEST = 'api/GET_STANDING_STRIP_REQUEST';
export const GET_STANDING_STRIP_SUCCESS = 'api/GET_STANDING_STRIP_SUCCESS';
export const GET_STANDING_STRIP_ERROR = 'api/GET_STANDING_STRIP_ERROR';

// Get Standing Phase
export const GET_STANDINGS_PHASE_REQUEST = 'api/GET_STANDINGS_PHASE_REQUEST';
export const GET_STANDINGS_PHASE_SUCCESS = 'api/GET_STANDINGS_PHASE_SUCCESS';
export const GET_STANDINGS_PHASE_ERROR = 'api/GET_STANDINGS_PHASE_ERROR';

// Get Top Scorers
export const GET_TOP_SCORERS_REQUEST = 'api/GET_TOP_SCORERS_REQUEST';
export const GET_TOP_SCORERS_SUCCESS = 'api/GET_TOP_SCORERS_SUCCESS';
export const GET_TOP_SCORERS_ERROR = 'api/GET_TOP_SCORERS_ERROR';

// Get Header Info
export const GET_HEADER_INFO_REQUEST = 'api/GET_HEADER_INFO_REQUEST';
export const GET_HEADER_INFO_SUCCESS = 'api/GET_HEADER_INFO_SUCCESS';
export const GET_HEADER_INFO_ERROR = 'api/GET_HEADER_INFO_ERROR';

// Get Strip Match
export const GET_STRIP_MATCH_REQUEST = 'api/GET_STRIP_MATCH_REQUEST';
export const GET_STRIP_MATCH_SUCCESS = 'api/GET_STRIP_MATCH_SUCCESS';
export const GET_STRIP_MATCH_ERROR = 'api/GET_STRIP_MATCH_ERROR';

//Get Calendar
export const GET_CALENDAR_REQUEST = 'api/GET_CALENDAR_REQUEST';
export const GET_CALENDAR_SUCCESS = 'api/GET_CALENDAR_SUCCESS';
export const GET_CALENDAR_ERROR = 'api/GET_CALENDAR_ERROR';

export const GET_DAY_CALENDAR_REQUEST = 'api/GET_DAY_CALENDAR_REQUEST';
export const GET_DAY_CALENDAR_SUCCESS = 'api/GET_DAY_CALENDAR_SUCCESS';
export const GET_DAY_CALENDAR_ERROR = 'api/GET_DAY_CALENDAR_ERROR';

export const GET_RUGBY_TABBAR_REQUEST = 'api/GET_RUGBY_TABBAR_REQUEST';
export const GET_RUGBY_TABBAR_SUCCESS = 'api/GET_RUGBY_TABBAR_SUCCESS';
export const GET_RUGBY_TABBAR_ERROR = 'api/GET_RUGBY_TABBAR_ERROR';

export const GET_RUGBY_CALENDAR_REQUEST = 'api/GET_RUGBY_CALENDAR_REQUEST';
export const GET_RUGBY_CALENDAR_SUCCESS = 'api/GET_RUGBY_CALENDAR_SUCCESS';
export const GET_RUGBY_CALENDAR_ERROR = 'api/GET_RUGBY_CALENDAR_ERROR';

// Get Calendar Corriere
export const GET_CALENDAR_CORRIERE_REQUEST = 'api/GET_CALENDAR_CORRIERE_REQUEST';
export const GET_CALENDAR_CORRIERE_SUCCESS = 'api/GET_CALENDAR_CORRIERE_SUCCESS';
export const GET_CALENDAR_CORRIERE_ERROR = 'api/GET_CALENDAR_CORRIERE_ERROR';

// Get Day Calendar Corriere
export const GET_DAY_CALENDAR_CORRIERE_REQUEST = 'api/GET_DAY_CALENDAR_CORRIERE_REQUEST';
export const GET_DAY_CALENDAR_CORRIERE_SUCCESS = 'api/GET_DAY_CALENDAR_CORRIERE_SUCCESS';
export const GET_DAY_CALENDAR_CORRIERE_ERROR = 'api/GET_DAY_CALENDAR_CORRIERE_ERROR';

// Get Cup Calendar Corriere
export const GET_CUP_CALENDAR_CORRIERE_REQUEST = 'api/GET_CUP_CALENDAR_CORRIERE_REQUEST';
export const GET_CUP_CALENDAR_CORRIERE_SUCCESS = 'api/GET_CUP_CALENDAR_CORRIERE_SUCCESS';
export const GET_CUP_CALENDAR_CORRIERE_ERROR = 'api/GET_CUP_CALENDAR_CORRIERE_ERROR';

// Get Day Cup Calendar Corriere
export const GET_DAY_CUP_CALENDAR_CORRIERE_REQUEST = 'api/GET_DAY_CUP_CALENDAR_CORRIERE_REQUEST';
export const GET_DAY_CUP_CALENDAR_CORRIERE_SUCCESS = 'api/GET_DAY_CUP_CALENDAR_CORRIERE_SUCCESS';
export const GET_DAY_CUP_CALENDAR_CORRIERE_ERROR = 'api/GET_DAY_CUP_CALENDAR_CORRIERE_ERROR';

//Get Leaf Event
export const GET_LEAF_EVENT_REQUEST = 'api/GET_LEAF_EVENT_REQUEST';
export const GET_LEAF_EVENT_SUCCESS = 'api/GET_LEAF_EVENT_SUCCESS';
export const GET_LEAF_EVENT_ERROR = 'api/GET_LEAF_EVENT_ERROR';

//Get Leaf Competition
export const GET_LEAF_COMPETITION_REQUEST = 'api/GET_LEAF_COMPETITION_REQUEST';
export const GET_LEAF_COMPETITION_SUCCESS = 'api/GET_LEAF_COMPETITION_SUCCESS';
export const GET_LEAF_COMPETITION_ERROR = 'api/GET_LEAF_COMPETITION_ERROR';

//Get Leaf Sport
export const GET_LEAF_SPORT_REQUEST = 'api/GET_LEAF_SPORT_REQUEST';
export const GET_LEAF_SPORT_SUCCESS = 'api/GET_LEAF_SPORT_SUCCESS';
export const GET_LEAF_SPORT_ERROR = 'api/GET_LEAF_SPORT_ERROR';

//Get Last Match
export const GET_NEXT_MATCH_REQUEST = 'api/GET_NEXT_MATCH_REQUEST';
export const GET_NEXT_MATCH_SUCCESS = 'api/GET_NEXT_MATCH_SUCCESS';
export const GET_NEXT_MATCH_ERROR = 'api/GET_NEXT_MATCH_ERROR';

// probabili request
export const GET_PROBABILI_REQUEST = 'api/GET_PROBABILI_REQUEST';
export const GET_PROBABILI_SUCCESS = 'api/GET_PROBABILI_SUCCESS';
export const GET_PROBABILI_ERROR = 'api/GET_PROBABILI_ERROR';

// probabili request home
export const GET_PROBABILI_HOME_REQUEST = 'api/GET_PROBABILI_HOME_REQUEST';
export const GET_PROBABILI_HOME_SUCCESS = 'api/GET_PROBABILI_HOME_SUCCESS';
export const GET_PROBABILI_HOME_ERROR = 'api/GET_PROBABILI_HOME_ERROR';

// probabili request away
export const GET_PROBABILI_AWAY_REQUEST = 'api/GET_PROBABILI_AWAY_REQUEST';
export const GET_PROBABILI_AWAY_SUCCESS = 'api/GET_PROBABILI_AWAY_SUCCESS';
export const GET_PROBABILI_AWAY_ERROR = 'api/GET_PROBABILI_AWAY_ERROR';

//Get WorldCup
export const GET_WORLD_CUP_REQUEST = 'api/GET_WORLD_CUP_REQUEST';
export const GET_WORLD_CUP_SUCCESS = 'api/GET_WORLD_CUP_SUCCESS';
export const GET_WORLD_CUP_ERROR = 'api/GET_WORLD_CUP_ERROR';

//Get World Cup Calendar
export const GET_WORLD_CUP_CALENDAR_REQUEST = 'api/GET_WORLD_CUP_CALENDAR_REQUEST';
export const GET_WORLD_CUP_CALENDAR_SUCCESS = 'api/GET_WORLD_CUP_CALENDAR_SUCCESS';
export const GET_WORLD_CUP_CALENDAR_ERROR = 'api/GET_WORLD_CUP_CALENDAR_ERROR';
export const GET_WORLD_CUP_DAY_CALENDAR_REQUEST = 'api/GET_WORLD_CUP_DAY_CALENDAR_REQUEST';
export const GET_WORLD_CUP_DAY_CALENDAR_SUCCESS = 'api/GET_WORLD_CUP_DAY_CALENDAR_SUCCESS';
export const GET_WORLD_CUP_DAY_CALENDAR_ERROR = 'api/GET_WORLD_CUP_DAY_CALENDAR_ERROR';

//Bet API
export const GET_BET_REQUEST = 'api/GET_BET_REQUEST';
export const GET_BET_SUCCESS = 'api/GET_BET_SUCCESS';
export const GET_BET_ERROR = 'api/GET_BET_ERROR';

// Get Team Calendar
export const GET_TEAM_CALENDAR_REQUEST = 'api/GET_TEAM_CALENDAR_REQUEST';
export const GET_TEAM_CALENDAR_SUCCESS = 'api/GET_TEAM_CALENDAR_SUCCES';
export const GET_TEAM_CALENDAR_ERROR = 'api/GET_TEAM_CALENDAR_ERROR';

// Get LineUp
export const GET_SQUAD_REQUEST = 'api/GET_SQUAD_REQUEST';
export const GET_SQUAD_SUCCESS = 'api/GET_SQUAD_SUCCESS';
export const GET_SQUAD_ERROR = 'api/GET_SQUAD_ERROR';

// Get Report List
export const GET_REPORT_LIST_REQUEST = 'api/GET_REPORT_LIST_REQUEST';
export const GET_REPORT_LIST_SUCCESS = 'api/GET_REPORT_LIST_SUCCESS';
export const GET_REPORT_LIST_ERROR = 'api/GET_REPORT_LIST_ERROR';
export const GET_REPORT_HEADER_INFO_SUCCESS = 'api/GET_REPORT_HEADER_INFO_SUCCESS';

// Get Calendar Gazzanet
export const GET_CALENDAR_GAZZANET_REQUEST = 'api/GET_CALENDAR_GAZZANET_REQUEST';
export const GET_CALENDAR_GAZZANET_SUCCESS = 'api/GET_CALENDAR_GAZZANET_SUCCESS';
export const GET_CALENDAR_GAZZANET_ERROR = 'api/GET_CALENDAR_GAZZANET_ERROR';

// Favourites
export const FAVOURITES_CHANGE = 'favourites/FAVOURITES_CHANGE';
export const FAVOURITES_MATCH = 'favourites/FAVOURITES_MATCH';
export const FAVOURITES_COUNTER = 'favourites/FAVOURITES_COUNTER';
export const SET_FAVOURITES_COMPETITIONS_LIST = 'favourites/SET_FAVOURITES_COMPETITIONS_LIST';
export const UPDATE_FAVOURITES = 'favourites/UPDATE_FAVOURITES';
export const REMOVE_FAVOURITES_MATCH = 'favourites/REMOVE_FAVOURITES_MATCH';
export const SET_IS_FAVOURITE = 'favourites/SET_IS_FAVOURITE';
export const SET_IS_FAVOURITE_RACE = 'favourites/SET_IS_FAVOURITE_RACE';

//Local Storage
export const CLEAR_LOCAL_STORAGE = 'localStorage/CLEAR_LOCAL_STORAGE';
export const SET_LOCAL_STORAGE_DATE = 'locaStorage/SET_LOCAL_STORAGE_DATE';
export const SET_LOCAL_STORAGE_DATE_RACE = 'locaStorage/SET_LOCAL_STORAGE_DATE_RACE';
export const REMOVE_FAVOURITES_MATCH_FROM_LOCALSTORAGE = 'localStorage/REMOVE_FAVOURITES_MATCH_FROM_LOCALSTORAGE';
export const UPDATE_LOCAL_STORAGE = 'localStorage/UPDATE_LOCAL_STORAGE';
export const INCREMENT_SESSION_COUNTER = 'localStorage/INCREMENT_SESSION_COUNTER';

// Timing Tag
export const PREMATCH = 'PreMatch';
export const FULLTIME = 'FullTime';
export const FULLTIME90 = 'FullTime90';
export const FULLTIMEPENS = 'FullTimePens';
export const SHOOTOUT = 'ShootOut';
export const ABANDONED = 'Abandoned';
export const POSTPONED = 'Postponed';
export const DELAYED = 'Delayed';
export const SUSPENDED = 'Suspended';
export const HALFTIME = 'HalfTime';
export const EXTRAHALFTIME = 'ExtraHalfTime';
export const FIRSTHALF = 'FirstHalf';
export const SECONDHALF = 'SecondHalf';
export const EXTRAFIRSTHALF = 'ExtraFirstHalf';
export const EXTRASECONDHALF = 'ExtraSecondHalf';
// Match Status
export const ABANDONED_STATUS = 'ABANDONED';
export const DELAYED_STATUS = 'DELAYED';
export const POSTPONED_STATUS = 'POSTPONED';
// SUSPANDED
export const PREMATCH_STATUS = 'PREMATCH';
export const LIVE_STATUS = 'LIVE';
// Stato interno non ritornato dalle api
export const AFTER_LIVE_STATUS = 'AFTERLIVE';
export const FULL_STATUS = 'FULL';

// Report types
export const GOALS = 'goal';
export const YELLOWCARD = 'yellow_card';
export const REDCARD = 'red_card';
export const START_FIRST_HALF = 'start_1';
export const START_FIRST_HALF_MANUAL = 'kick_off';
export const END_FIRST_HALF = 'end_1';
export const END_FIRST_HALF_MANUAL = 'half_time';
export const START_SECOND_HALF = 'start_2';
export const START_SECOND_HALF_MANUAL = 'second_half';
export const END_SECOND_HALF = 'end_2';
export const END_SECOND_HALF_MANUAL = 'full_time';
export const END_SECOND_HALF_MANUAL_2 = 'end_14';
export const LINE_UP = 'lineup';
export const PENALTY = 'penalty_lost';
export const SUBSTITUTION = 'substitution';
export const OWNGOAL = 'own_goal';
export const VAR = 'contentious_referee_decisions';
export const ASSIST = 'assist';

//Local storage keys
export const PREFERRED_COUNTER = 'preferredCount';
export const PREFERRED_MATCH = 'preferredMatch';
export const PREFERRED_MAP = 'preferredMap';
export const SESSION_COUNTER = 'sessionCount';

// Race Status
export const NOTSTARTED = 'NOTSTARTED';
export const ON_TRACK = 'ON TRACK';
export const FINISHED = 'FINISHED';
export const RED_FLAG = 'RED FLAG';
export const YELLOW_FLAG = 'YELLOW FLAG';
export const SAFETY_CAR = 'SAFETY CAR';
export const ABORTED = 'ABORTED';

// Race Session
export const RACE = 'RACE';

//Tennis Status
export const INPLAY = 'INPLAY';
export const BYE = 'BYE';
export const WALKOVER = 'WALKOVER';
export const RETIRED = 'RETIRED';
export const DEFAULTED = 'DEFAULTED';
export const WIN = 'WIN';
export const SUSPENDED_STATUS = 'SUSPENDED';

// Tennis competition type
export const MENS_SINGLES = 'Mens Singles';
export const WOMENS_SINGLES = 'Womens Singles';
export const COMPETITION_TYPE_MAN = 'Mens';
export const COMPETITION_TYPE_WOMAN = 'woman';

// Tracking Common Code seriea champions e gazzanet
export const TRACK_STRING_CONST = '?vclk=fasciaTR';


// Driver standings
export const GET_DRIVER_STANDINGS_REQUEST = 'api/GET_DRIVER_STANDINGS_REQUEST';
export const GET_DRIVER_STANDINGS_SUCCESS = 'api/GET_DRIVER_STANDINGS_SUCCESS';
export const GET_DRIVER_STANDINGS_ERROR = 'api/GET_DRIVER_STANDINGS_ERROR';

// Constructor standings
export const GET_CONSTRUCTOR_STANDINGS_REQUEST = 'api/GET_CONSTRUCTOR_STANDINGS_REQUEST';
export const GET_CONSTRUCTOR_STANDINGS_SUCCESS = 'api/GET_CONSTRUCTOR_STANDINGS_SUCCESS';
export const GET_CONSTRUCTOR_STANDINGS_ERROR = 'api/GET_CONSTRUCTOR_STANDINGS_ERROR';
export const GET_TEAMS_STANDINGS_REQUEST = 'api/GET_TEAMS_STANDINGS_REQUEST';

// Rugby Status
export const RESULT = 'RESULT';
export const FIXTURE = 'FIXTURE';

// Internal router
export const SET_ROUTE = 'internalRouter/SET_ROUTE';



// WEBPACK FOOTER //
// ./src/constants/index.js